<template>
    <div>
        <content-view v-show="$utils.renderWhen(this,'materielImport')">
            <div class="wrap-container-in">
                <div class="mb24">
                    <a-button type="primary" @click="showImportModelSelect">导入模板下载</a-button>
                    <a-button type="primary" @click="visibleUploadVerification = true">文件上传</a-button>
                </div>
                <a-table
                bordered
                :columns="columns1"
                :dataSource="dataSource1"
                :pagination="pagination1"
                :rowKey="record => record.id"
                :loading="tableLoading"
                @change="changePage1"
                class="wrap-table"
                >
                    <template slot="index" slot-scope="key, row, index">
                        {{index + 1}}
                    </template>
                    <template slot="actions" slot-scope="key, row">
                        <a v-if="getBtnByAuth('updateStorage')" class="text-primary" :href="row.uploadUrl" :download="`${row.createTime}_上传.xlsx`">上传表格下载</a>
                        <span v-else class="text-disabled">上传表格下载</span>
                        <a-divider type="vertical"/>
                        <a class="text-primary" v-if="getBtnByAuth('updateStorage')" :href="row.errorUrl" :download="`${row.createTime}_失败数据.xlsx`">失效数据下载</a>
                        <span v-else class="text-disabled">失效数据下载</span>
                    </template>
                </a-table>
            </div>
            <a-modal
            title="模板选择"
            centered
            :visible="visibleImportModelSelect"
            @cancel="visibleImportModelSelect = false"
            :width="400"
            :maskClosable="false"
            >
                <a-row>
                    <a-col class="text-center" :span="12">
                        <a-button type="primary" @click="getSelfGoodsTemplate(0)" :loading="downloadLoaing">无条形码商品</a-button>
                    </a-col>
                    <a-col class="text-center" :span="12">
                        <a-button type="primary" @click="getSelfGoodsTemplate(1)" :loading="downloadLoaing">有条形码商品</a-button>
                    </a-col>
                </a-row>
                <template slot="footer">
                    <a-button @click="visibleImportModelSelect = false">取消</a-button>
                </template>
            </a-modal>
            <a-modal
            title="文件上传"
            centered
            :width="600"
            :destroyOnClose="true"
            :visible="visibleUploadVerification"
            @cancel="visibleUploadVerification = false"
            :maskClosable="false"
            >
                <div>
                    <a-upload
                        name="file"
                        :multiple="false"
                        @change="handleChange"
                        accept=".xlsx"
                        :beforeUpload="beforeUpload"
                        :customRequest="customRequest"
                    >
                        <a-button type="primary"><a-icon type="upload" />请选择您要上传的文件</a-button>
                    </a-upload>
                    <div class="mt16">
                        商品导入仓库：{{mainWarehouseInfo.warehouseName}}
                    </div>
                </div>
                <template slot="footer">
                    <div class="text-center">
                        <a-button type="primary" @click="uploadVerification">请验证您要上传的文件</a-button>
                    </div>
                </template>
            </a-modal>
            <a-modal
            title="导入确认"
            centered
            :width="600"
            :destroyOnClose="true"
            :visible="visibleConfirmUpload"
            @cancel="confirmUploadCancel"
            :maskClosable="false"
            >
                <div>
                    <div class="text-color-85 mb16">
                        导入仓库：{{mainWarehouseInfo.warehouseName}}，导入数据：{{uploadRes.totalNum}} 条，其中：
                    </div>
                    <div class="verification-result">
                        <div>新增商品/条：{{uploadRes.insertNum}}</div>
                        <div>更新商品/条：{{uploadRes.editNum}}</div>
                        <div>
                            重复导入商品/条：{{uploadRes.repeatNum}} 
                            <template v-if="uploadRes.repeatNum > 0">
                                导入数量已合并，
                                <a class="text-primary" @click="visibleVerificationResultRepeatTable = true">查看</a>
                            </template>
                        </div>
                        <div>存在导入错误数据/条：{{uploadRes.errorNum}}<span class="ml8">将不导入</span></div>
                    </div>
                </div>
                <template slot="footer">
                    <a-button :loading="confirmUploadLoading" @click="visibleConfirmUpload = false">取消</a-button>
                    <a-button :loading="confirmUploadLoading" @click="selfSubmitTemplate" type="primary">确认导入</a-button>
                </template>
            </a-modal>
            <a-modal
            title="重复导入商品查看"
            centered
            :width="1200"
            :visible="visibleVerificationResultRepeatTable"
            @cancel="visibleVerificationResultRepeatTable = false"
            :maskClosable="false"
            >
                <a-table
                bordered
                :columns="columns2"
                :dataSource="uploadRes.repeatCollect"
                :pagination="pagination2"
                :rowKey="record => record.id"
                @change="changePage2"
                class="wrap-table"
                >
                    <template slot="useType" slot-scope="key, row, index">
                        {{['', '售卖', '自用'][key]}}
                    </template>
                </a-table>
                <template slot="footer">
                    <a-button type="primary"  @click="visibleVerificationResultRepeatTable = false">确认</a-button>
                </template>
            </a-modal>
        </content-view>
        <router-view></router-view>
    </div>
</template>

<script type="text/javascript">
    import { mapGetters } from "vuex";
    const columns1 = [
        {
            title: '序号',
            scopedSlots: {customRender: 'index'}
        },
        {
            title: '上传文件名称',
            dataIndex: 'fileName'
        },
        {
            title: '上传时间',
            dataIndex: 'createTime'
        },
        {
            title: '上传人',
            dataIndex: 'uploadUserName'
        },
        {
            title: '操作',
            dataIndex: 'id',
            scopedSlots: { customRender: 'actions'}
        }
    ];
    const columns2 = [
        {
            title: '所在行',
            dataIndex: 'rowNum'
        },
        {
            title: '商品名称',
            dataIndex: 'goodsName'
        },
        {
            title: '商品规格',
            dataIndex: 'goodsSpecification'
        },
        {
            title: '基本单位',
            dataIndex: 'goodsUnit'
        },
        {
            title: '商品分组',
            dataIndex: 'goodsCategory'
        },
        {
            title: '使用类型',
            dataIndex: 'useType',
            scopedSlots: { customRender: 'useType' }
        },
        {
            title: '商品成本价',
            dataIndex: 'costPrice'
        },
        {
            title: '商品售卖价',
            dataIndex: 'sellPrice'
        },
        {
            title: '本次入库数',
            dataIndex: 'currentInventory'
        },
    ];
    export default {
        name: 'materielImport',
        components: {},
        props: {},
        data() {
            return {
                columns1,
                columns2,
                dataSource1: [],
                tableLoading: false,
                visibleImportModelSelect: false,
                visibleUploadVerification: false,
                visibleConfirmUpload: false,
                visibleVerificationResultRepeatTable: false,
                pagination1: {
                    showTotal: total => `共 ${total} 条数据`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: 0,
                    current: 1,
                    pageSize: 20
                },
                pagination2: {
                    showTotal: total => `共 ${total} 条数据`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: 0,
                    current: 1,
                    pageSize: 20
                },
                downloadLoaing: false,
                mainWarehouseInfo: {},
                uploadRes: {
                    editNum:0,
                    errorNum:0,
                    insertNum:0,
                    repeatCollect:[],
                    repeatNum:0,
                    totalNum:0
                },
                confirmUploadLoading: false
            };
        },
        watch: {},
        computed: {
            ...mapGetters(["shopId"])
        },
        methods: {
            changePage1(page) {
                this.pagination1 = page;
                this.getUploadRecord();
            },
            changePage2(page) {
                this.pagination2 = page;
            },
            /**
             * @showImportModelSelect 显示导入模板选择
             */
            showImportModelSelect() {
                this.visibleImportModelSelect = true;
            },
            /**
             * @getUploadRecord 批量商品导入记录
             */
            getUploadRecord() {
                if (!this.shopId || this.tableLoading) {
                    return false;
                }
                this.tableLoading = true;
                this.$api.newStorage.selfUploadRecord({
                    body: {
                        shopId: this.shopId,
                        pageNum: this.pagination1.current,
                        pageSize: this.pagination1.pageSize
                    }
                }).then(res => {
                    if (res && res.data) {
                        this.dataSource1 = res.data;
                    }
                    this.pagination1.total = res.total;
                    this.tableLoading = false;
                }).catch(err => {
                    this.tableLoading = false;
                });
            },
            /**
             * @getSelfGoodsTemplate 商品导入模板选择
             */
            getSelfGoodsTemplate(templateType) {
                let templateNames = ['无条形码商品批量导入excel模板', '有条形码商品批量导入excel模板'];
                this.downloadLoaing = true;
                this.$api.newStorage.selfGoodsTemplate({
                    body: {
                        shopId: this.shopId,
                        templateType
                    },
                }, {
                    responseType: 'blob'
                }).then(res => {
                    let a = document.createElement("a");
                    let blob = new Blob([res.data], {
                        type: "vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    });
                    let downloadUrl = window.URL.createObjectURL(blob);
                    let name = templateNames[templateType] + '.xlsx'
                    a.setAttribute("href", downloadUrl);
                    a.setAttribute("download", name);
                    a.click();
                    this.visibleImportModelSelect = false;
                    this.downloadLoaing = false;
                }).catch(err => {
                    this.downloadLoaing = false;
                });
            },
            /**
             * @handleChange 导入文件选择
             */
            handleChange(info) {
                //上传成功
                if (info.file.status === 'done') {
                    this.$message.success(`${info.file.name} 上传成功`);
                } else if (info.file.status === 'error') {
                    this.$message.error(`${info.file.name} 上传失败`);
                }
            },
            
            /**
             * @beforeUpload 上传前拦截
             */
            beforeUpload(file, fileList) {
                // 可用于校验文件
                return true;
            },
            /**
             * @customRequest 自定义上传
             */
            customRequest({ onSuccess, onError, onProgress, file }) {
                let formData = new FormData();
                formData.append('file', file);
                this.$api.newStorage.selfBatchGoodsImport({
                    body: formData,
                    query: {
                        shopId: this.shopId,
                        uploadUserName: this.userInfo.name
                    }
                }, {
                    // 请求额外参数
                    header: {
                        'Content-Type': 'multipart/form-data'
                    },
                    onUploadProgress: ({ total, uploaded }) => {
                        onProgress({ percent: uploaded / total * 100 })
                    }
                }).then(res => {
                    this.uploadRes = res;
                    this.pagination2.total = res.repeatCollect.length;
                    this.visibleUploadVerification = false;
                    setTimeout(() => {
                        this.visibleConfirmUpload = true;
                    });
                    onSuccess();
                })
                .catch(err => {
                    onError();
                })
            },
            /**
             * @uploadVerification 验证上传文件
             */
            uploadVerification() {
                this.visibleConfirmUpload = true;
            },
            /**
             * @getSelfMainWarehouse 获取门店对应的主仓库
             */
            getSelfMainWarehouse() {
                if (!this.shopId) {
                    return false;
                }
                this.$api.newStorage.getSelfMainWarehouse({
                    query: {
                        shopId: this.shopId
                    }
                }).then(res => {
                    this.mainWarehouseInfo = res;
                });
            },
            /**
             * @selfSubmitTemplate 确认上传
             */
            selfSubmitTemplate() {
                this.confirmUploadLoading = false;
                this.$api.newStorage.selfSubmitTemplate({
                    query: {
                        shopId: this.shopId,
                        uploadUserName: this.userInfo.name
                    }
                }).then(res => {
                    this.visibleConfirmUpload = false;
                    this.confirmUploadLoading = false;
                    this.getUploadRecord();
                });
            },
            /**
             * @confirmUploadCancel 确认上传取消按钮
             */
            confirmUploadCancel() {
                if(this.confirmUploadLoading) {
                    return false;
                }
                this.visibleConfirmUpload = false;
            },
        },
        beforeCreate() {
            this.userInfo = this.$userInfoTool.getUser();
        },
        created() {},
        mounted() {
            this.getSelfMainWarehouse();
            this.getUploadRecord();
        },
        watch: {
            shopId() {
                this.pagination1.current = 1;
                this.pagination2.current = 1;
                this.getSelfMainWarehouse();
                this.getUploadRecord();
            }
        }
    };
</script>
<style lang="scss">
.wrap-container-in {
    background-color: #fff;
    padding: 24px 32px;
    border-radius: 2px;
}
.verification-result {
    background-color: #efefef;
    padding: 16px;
    div {
        margin-bottom: 6px;
        &:last-child {
            margin-bottom: 0px;
        }
    }
}
</style>
